/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/kendo-ui/kendo-ui.d.ts" />

namespace Application.Directives {
    'use strict';
    /**
     * Factory callback type
     */
    declare type EurovisionAutocompleteDirectiveCb = ($timeout: ng.ITimeoutService) => EurovisionAutocompleteDirective;

    /**
     * Custom scope
     */
    export interface IEurovisionAutocompleteDirectiveScopeDef {
        options: string;
        text: string;
        onChange: string;
        desc: string;
        icon: string;
        searchField: string;
        customId: string;
        dataTextField: string;
    }

    export interface IEurovisionAutocompleteDirectiveScope extends ng.IScope {
        options: string[] | number[] | Object[];
        text: string;
        onChange: (value: Object) => void;
        desc: string;
        icon: string;
        searchField: string;
        input: kendo.ui.AutoComplete;
        customId: string;
        dataTextField: string;
    }
    
    export class EurovisionAutocompleteDirective implements ng.IDirective {
        public static $name: string = "eurovisionAutocomplete";
        public static $inject: string[] = ['$timeout'];
        
        public restrict: string = 'E';
        public replace: boolean = true;
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/eurovision-autocomplete-directive.html';
        public link: (scope: IEurovisionAutocompleteDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public scope: IEurovisionAutocompleteDirectiveScopeDef = {
            options: '=',
            text: '@',
            onChange: '&',
            desc: '@',
            icon: '@',
            searchField: '@',
            customId: '@',
            dataTextField: '@',
        };

        public static Factory(): EurovisionAutocompleteDirectiveCb {
            let directive: EurovisionAutocompleteDirectiveCb = ($timeout: ng.ITimeoutService) => {
                return new EurovisionAutocompleteDirective($timeout);
            };
            directive.$inject = ['$timeout'];
            return directive;
        }

        constructor($timeout: ng.ITimeoutService) {
            EurovisionAutocompleteDirective.prototype.link = (scope: IEurovisionAutocompleteDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                if (scope.text === undefined)
                    scope.text = 'name';
                let descriptionTemplate: string = '<span class="uk-text-muted uk-text-small"></span>';
                if (scope.desc)
                    descriptionTemplate = '<span class="uk-text-muted uk-text-small">#: data.' + scope.desc + ' #</span>';
                $timeout(() => {
                    scope.input = $("#" + scope.customId).kendoAutoComplete({
                        select: function(e: any): void { // tslint:disable-line
                            let item: Object = this.dataItem(e.item.index());
                            $timeout(() => {
                                scope.input.value("");
                            });
                            scope.onChange({value: item});
                        },
                        dataSource: scope.options,
                        filter: "contains",
                        dataTextField: scope.dataTextField,
                        template: '<div class="k-list-wrapper">' +
                                        '<span class="k-state-default k-list-wrapper-addon">' +
                                            '<img src="#:data.' + scope.icon + '#" alt=\"#:data.' + scope.text + '#\" />' +
                                        '</span>' +
                                    '<span class="k-state-default k-list-wrapper-content">' +
                                        '<p>#: data.' + scope.text + ' #</p>' + descriptionTemplate +
                                    '</span>' +
                                '</div>',
                    }).data("kendoAutoComplete");
                });

                scope.$watch('options', (newValue: Object, oldValue: Object) => {
                    if (newValue !== undefined && newValue !== oldValue) {
                        let options: kendo.data.DataSource = new kendo.data.DataSource({
                            data: newValue,
                        });
                        if (scope.input) {
                            scope.input.setDataSource(options);
                        }
                    }
                }, true);

                scope.$on('$destroy', () => {
                    if (scope.input)
                        scope.input.destroy();
                });
            };
        }
    }
}